import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { HomeRankSectionRoutingModule } from './homeranksection-routing.module';
import { HrsectionListComponent } from './hrsection-list/hrsection-list.component';
import { HrsectionCreateComponent } from './hrsection-create/hrsection-create.component';

@NgModule({
  declarations: [HrsectionListComponent, HrsectionCreateComponent],
  imports: [
    CommonModule,
    HomeRankSectionRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class HomeRankSectionModule { }
